module.exports = __webpack_public_path__ + "img/learnba.eef33b67.png";